import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";

import HomePage from "./pages/HomePage";
import PackagesPage from "./pages/PackagesPage";
import BuildPage from "./pages/BuildPage";
import BookPage from "./pages/BookPage";
import CheckoutPage from "./pages/CheckoutPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import AssessmentPage from "./pages/AssessmentPage";
import PortalPage from "./pages/PortalPage";
import DoctorPage from "./pages/DoctorPage";
import LegalPage from "./pages/LegalPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import { NotFoundPage, SessionExpiredPage, ErrorBoundary } from "./pages/StatusPages";
import MobileShell from "./mobile/MobileShell";
import MobileLoginPage from "./mobile/MobileLoginPage";
import HomeScreen from "./mobile/HomeScreen";
import MyPlanScreen from "./mobile/MyPlanScreen";
import ProgressScreen from "./mobile/ProgressScreen";
import CoachScreen from "./mobile/CoachScreen";
import ProfileScreen from "./mobile/ProfileScreen";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isPortal = pathname.startsWith("/portal");
  const isDoctor = pathname.startsWith("/doctor");
  const isMobile = pathname.startsWith("/m/") || pathname === "/m";
  const chrome = !isAdmin && !isPortal && !isDoctor && !isMobile && !pathname.startsWith("/session-expired");

  return (
    <div className="App">
      {chrome && <Header />}
      {chrome && <CartDrawer />}
      <main>
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/build" element={<BuildPage />} />
          <Route path="/book" element={<BookPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/assessment" element={<AssessmentPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/portal" element={<PortalPage />} />
          <Route path="/doctor" element={<DoctorPage />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

          {/* Mobile PWA app shell */}
          <Route path="/m/login" element={<MobileLoginPage />} />
          <Route path="/m" element={<MobileShell />}>
            <Route index element={<HomeScreen />} />
            <Route path="home" element={<HomeScreen />} />
            <Route path="plan" element={<MyPlanScreen />} />
            <Route path="progress" element={<ProgressScreen />} />
            <Route path="coach" element={<CoachScreen />} />
            <Route path="profile" element={<ProfileScreen />} />
          </Route>

          <Route path="/session-expired" element={<SessionExpiredPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </ErrorBoundary>
      </main>
      {chrome && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Shell />
      </BrowserRouter>
    </CartProvider>
  );
}
